import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, Card, FormControl, InputLabel, Select, CardContent, Typography, TextField, CardActions } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 500,
        ['@media (max-width:600px)']: {
            minWidth: 250,
        },
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '16px',
        paddingTop: '15px',
        ['@media (max-width:600px)']: {
            paddingTop: '25px',
        },
    },
    inLabel: {
        fontSize: '1.5rem',
        letterSpacing: '0.09rem',
        color: '#000000',
        fontFamily: 'Rubik !important',
    },
    cardContent: {
        paddingLeft: '24px',
        paddingTop: '10px',
        fontFamily: 'Rubik !important',
    },
    type4: {
        margin: theme.spacing(2),
        fontSize: '1.5rem',
        fontFamily: 'Rubik',
        fontWeight: '500',
    },
    cardAction: {
        marginLeft: '30px',
        paddingBottom: '30px',
    },
    button1: {
        marginRight: '25px',
    },
    button2: {
        margin: '0px',
    },
    popbutton: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
        // autofocus: 'none !important',
    },
}));

export default function CrcDialog(props) {
    const { itecOpen, handleItecClose, crcRemarks, crcCategory, relevanceindex } = props;
    // const [open, setOpen] = React.useState(itecOpen);
    //console.log("Remarks from General info in PopUp" ,crcRemarks );
    //console.log("Category in PopUp" , crcCategory)
    const classes = useStyles();
    const [category, setCategory] = React.useState(crcCategory);
    const [open, setOpen] = React.useState(false);
    const [relevanceReview, setRelevanceReview] = React.useState(crcRemarks);
    const [ITRButton, setITRButton] = useState(false);

    // const limitCharacters = 10;
    // const limitCharacter = {
    //     step: 10,
    //   };

    //On Select
    const handleChange = (event) => {
        setCategory(event.target.value);
    };

    //controlled Select
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    // const limitCharacters = (e) => {
    //     if(e) {
    //         e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,500);
    //     } else {
    //         return
    //     }
    // }

    const handleSave = (e) => {
        e.preventDefault();
        setITRButton(true);
        //console.log('relevanceReview', relevanceReview);
        // props.updateCRCRelevance(category, relevanceReview);
        props.updateCRCRelevance(category, relevanceReview, relevanceindex);
    };

    const handleTextChange = (event) => {
        //console.log("text", event.target.value);
        setRelevanceReview(event.target.value);
    };

    return (
        <div>
            <Dialog
                open={itecOpen}
                onClose={handleItecClose}
                maxWidth="sm"
                fullWidth
                aria-labelledby="customized-dialog-title"
                // disableBackdropClick
            >
                <Card>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="h4" className={classes.type4}>
                            {' '}
                            Add Relevance
                        </Typography>
                    </CardContent>

                    <DialogContent>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="type-account" htmlFor="type-account" className={classes.inLabel} shrink>
                                Relevance Category
                            </InputLabel>
                            <Select
                                native
                                id="category"
                                open={open}
                                onClose={handleClose}
                                onOpen={handleOpen}
                                value={category}
                                onChange={handleChange}
                                inputProps={{
                                    name: 'Relevence Category',
                                    id: 'type-account',
                                }}
                                IconComponent={() => <FontAwesomeIcon icon={faAngleDown} />}
                                className={classes.bottomLine}
                            >
                                <option value="" selected disabled hidden>
                                    Select the Relevance Category
                                </option>
                                <option value="Relevant">Relevant</option>
                                <option value="Irrelavant">Irrelevant</option>
                                <option value="Paritially Relevant">Partially Relevant</option>
                                {/* <option value="FD/RD">FD/RD</option> */}
                            </Select>
                        </FormControl>
                        {/* <CardContent className={classes.cardContent}> */}
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="relevence-remarks" shrink className={classes.inLabel}>
                                Relevance Remarks
                            </InputLabel>
                            <TextField
                                id="relevence-remarks"
                                multiline
                                rows={5}
                                placeholder="Enter Your Remarks"
                                InputProps={{
                                    classes: { root: classes.bottomLine },
                                }}
                                inputProps={{
                                    maxLength: 500,
                                }}
                                style={{ paddingTop: '15px' }}
                                value={relevanceReview}
                                onChange={handleTextChange}
                                // onInput={(e) => limitCharacters(e)}
                            />
                        </FormControl>
                        {/* </CardContent> */}
                    </DialogContent>
                    <CardActions className={classes.cardAction}>
                        <div className={classes.button1}>
                            <Button variant="outlined" color="primary" className={classes.popbutton} onClick={handleItecClose}>
                                {' '}
                                Cancel
                            </Button>
                        </div>
                        <div className={classes.button2}>
                            <Button
                                variant="outlined"
                                color="primary"
                                className={classes.popbutton}
                                // className="btn-email"
                                disabled={ITRButton}
                                onClick={handleSave}
                            >
                                {' '}
                                Save{' '}
                            </Button>
                        </div>
                    </CardActions>
                </Card>
            </Dialog>
        </div>
    );
}
